export const getSubdomain = (window) => {
  const host = window.location.host;
  const parts = host.split(".");
  return parts.length > 1 ? parts[0] : "";
};
